import React from "react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { SITE } from "@/lib/site";

export const WhatsAppFloat = () => (
  <a
    href={SITE.whatsappUrl}
    target="_blank"
    rel="noreferrer"
    className="wha-pulse fixed z-50 bottom-5 right-5 md:bottom-6 md:right-6 bg-[#25D366] text-white rounded-full p-4 shadow-xl hover:scale-110 hover:bg-[#1EBE57] transition-all flex items-center justify-center"
    aria-label="Chat on WhatsApp"
    data-testid="floating-whatsapp-button"
  >
    <WhatsAppIcon size={26} />
  </a>
);

export default WhatsAppFloat;
